<div>
    <div>
        <span class="text-info">Schedule :</span>
        <span class="ml-2">{{ _info?.getWeekDayScheduleDescription() }}</span>
    </div>
    <div *ngIf="_info && _info.weekend && _info.weekend.enabled">
        <span class="text-info">Weekend schedule :</span>
        <span class="ml-2">{{ _info?.getWeekendScheduleDescription() }}</span>
    </div>
</div>